var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},_vm._l((_vm.options),function(item,index){return _c('van-button',{key:index,class:_vm.currentIndex == index ? 'highLight' : '',attrs:{"type":"default"},on:{"click":function($event){return _vm.onClick(item, index)}}},[_vm._v(_vm._s(item))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }